import { gql } from '@apollo/client'
import { USER_MAIL_FRAGMENT } from 'graphql/mails/fragments'

export const TODAY_MEETINGS_QUERY = gql`
  query ParcelCollections {
    parcelCollections {
      id
      customerFullname
      destructionExpectedDate
      societyName
      startAt
      state
      userMail {
        ...UserMailFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
`
